import axios from 'axios'
import moment from 'moment'
import Config from '@/config'
import { AppState } from '@/state'
import CookieManager from '@/helpers/cookiemanager'
import { Enum } from '@/helpers/enum'

export const SportsKind = new Enum({
  Cricket: 'cricket',
  Football: 'football',
  Kabaddi: 'kabaddi'
})

export const DataFreshnessKind = new Enum({
  Live: 'live',
  Hot: 'hot',
  Warm: 'warm',
  Frozen: 'frozen'
})

let apiInstance = null
let isRzVariation = false

export const API = {
  cancelToken: axios.CancelToken,
  searchCancelToken: null,
  useFreshHeaderKey: 'RZ-USE-FRESH',
  forAppkeyHeaderKey: 'RZ-FOR-APPKEY',
  faKey: null,

  instance () {
    if (apiInstance == null) {
      const token = CookieManager.getItem('rzAccessToken')

      axios.defaults.params = {}
      axios.defaults.params['rz-app-key'] = Config.RZAppKey
      API.faKey = Config.FAKey

      apiInstance = axios.create({
        baseURL: Config.APIPath,
        headers: {
          'RZ-ACCESS-TOKEN': token
        },
        transformRequest: (data, headers) => {
          if (!headers[API.useFreshHeaderKey] || isRzVariation) {
            const urlParams = new URLSearchParams(window.location.search)
            const useFreshVal = urlParams.get('_usefresh')
            if (useFreshVal !== null) {
              headers[API.useFreshHeaderKey] = useFreshVal
              console.log('Added Use Fresh')
            }

            let forAppkey = urlParams.get('forAppkey')
            if (forAppkey !== null) {
              CookieManager.setItem('rzForAppkey', forAppkey, Number.Infinity, '/')
            }

            forAppkey = CookieManager.getItem('rzForAppkey')
            if (forAppkey !== null) {
              headers[API.forAppkeyHeaderKey] = forAppkey
            }
          }
          // headers['content-type'] = 'application/json'
          return axios.defaults.transformRequest[0](data, headers)
        }
      })

      this.prepareAPI(apiInstance)
    }
    return apiInstance
  },

  getUseFreshHeader (isVariation) {
    let params = {}
    if (isVariation) {
      isRzVariation = true
    }
    params[API.useFreshHeaderKey] = 1
    return params
  },

  prepareAPI () {
    apiInstance.interceptors.response.use(response => response, (error) => {
      if (error.response && error.response.status === 403) {
        if (CookieManager.hasItem('rzAccessToken')) {
          CookieManager.removeItem('rzAccessToken')
          console.log('Relogin required')
          // window.location.href = window.location.href;
        }
      }
      return Promise.reject(error)
    })
  },

  cancelSearch () {
    if (API.searchCancelToken) {
      API.searchCancelToken.cancel()
      API.searchCancelToken = API.cancelToken.source()
    }
  },

  loginUser (token) {
    const expires = moment().add(23, 'hours')
    CookieManager.setItem('rzAccessToken', token, expires.toDate())
    AppState.updateUserLoggedIn(true)
  }

}

API.searchCancelToken = API.cancelToken.source()

export class Team {
  static createFromJSON (raw) {
    let team = new Team()
    team = Object.assign(team, raw)
    return team
  }
}

export class LocalUserPref {
  static updateFetchMethod (newVal) {
    CookieManager.setItem('rzFetchMethod', newVal, Infinity, '/')
  }
  static fetchMethod (defaultVal) {
    const val = CookieManager.getItem('rzFetchMethod')
    if (val === null) {
      return defaultVal
    }
    return val
  }
}
